import { IUninstallMetaBusinessExtensionRequest } from "./types";
import { IRepoErrors } from "@/v2/repo/errors";
import { http } from "@/v2/repo/http";

export class UninstallMetaBusinessExtensionError extends Error {
  errors: IRepoErrors;

  constructor(errors: IRepoErrors) {
    super("Error in repo: UninstallMetaBusinessExtension");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

/**
 * {@link https://chatfood.stoplight.io/docs/chatfood-api-dashboard/branches/main/b371ecb65dec2-uninstall-meta-business-extension API Contract}
 */
export async function uninstallMetaBusinessExtension(
  request: IUninstallMetaBusinessExtensionRequest
): Promise<void> {
  try {
    await http.post(
      `v1/businesses/${request.businessId}/meta-business-extension/uninstall`
    );
  } catch (e: any) {
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    throw new UninstallMetaBusinessExtensionError(e);
  }
}
